import React from 'react';
import Grid from '@material-ui/core/Grid';
import {galleryPresets} from '../../data/gallery';
import GalleryItem from './galleryItem';
import Slider from '@material-ui/lab/Slider'
import {isMobile} from '../../utils';

import './motionGallery.scss';

export default class MotionGallery extends React.Component {

    constructor() {
        super();
        this.isMobile = isMobile();
        this.state = {scale: this.isMobile ? .6 : .3, showSnapshots: false, showPresets: true};
    }

    componentDidMount() {
        window.addEventListener('keydown', this.onKeyDown);
        
	}

	componentWillUnmount() {
		window.removeEventListener('keydown', this.onKeyDown);
	}

	onKeyDown = (e) => {
		const {onShowControllerChange, onGalleryModeChange} = this.props;
		
		switch(e.keyCode) {

            case 84: // t
                e.preventDefault();
                onShowControllerChange();
            
                return;
			
			case 71: // g 
                e.preventDefault();
                onGalleryModeChange();
            
				return;

			default:
				return;
		}
    }

    onScaleChange = (newScale) => {
        this.setState({scale: newScale / 100});
    }

    render() {
        const {scale, showSnapshots, showPresets} = this.state;
        const {savedSnapshots} = this.props;
        const savedSnapshotDates = Object.keys(savedSnapshots);
        
        return (
            <div className="motion-gallery">

                <div className="gallery-options">

                    <div className="gallery-scale-slider">
                        <div className="gallery-scale-label">Zoom</div>
                        <Slider
                            classes={{
                                thumb: 'slider-thumb',
                                trackBefore: 'slider-track-before',
                                trackAfter: 'slider-track-after'
                            }}
                            value={scale * 100}
                            min={0}
                            max={100}
                            step={5}
                            aria-labelledby="Scale"
                            onChange={(e, sliderValue) => {
                                this.onScaleChange(sliderValue)
                            }}
                        />
                    </div>

                    <div className="gallery-options-filter">
                        <div className={`show-presets ${showPresets && 'active'}`} onClick={() => {this.setState({showPresets: true, showSnapshots: false})}}>Presets</div>
                        <div className={`show-snapshots ${showSnapshots && 'active'}`} onClick={() => {this.setState({showPresets: false, showSnapshots: true})}}>Saved</div>
                    </div>
                </div>

                <Grid
                    container
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start"
                >
                    {showSnapshots && savedSnapshotDates.map((saveDate, index) => {
                        return <GalleryItem key={index} {...this.props} index={index} preset={savedSnapshots[saveDate].transitionOptions} scale={scale} savedDate={saveDate} />;
                    })}

                    {showPresets && galleryPresets.map((preset, index) => {
                        return <GalleryItem key={index} {...this.props} index={index} preset={preset} scale={scale} />;
                    })}
                </Grid>
            </div>
        )
    }
}